import { Pipe, PipeTransform } from '@angular/core';
import { DocumentType } from '../../../core/modules/documents/documents.types';

@Pipe({
  name: 'uniqueDocumentTypes',
  standalone: true,
})
export class UniqueDocumentTypesPipe implements PipeTransform {
  transform(allDocumentTypes: DocumentType[]): DocumentType[] {
    const alreadyAddedTypes = new Set<string>();

    return allDocumentTypes.filter((documentType) => {
      if (alreadyAddedTypes.has(documentType.shortName)) {
        return false;
      }
      alreadyAddedTypes.add(documentType.shortName);
      return true;
    });
  }
}
